import { Pipe, PipeTransform } from '@angular/core';
import { IApiPhoto } from "../modules/graphql/types/types";

@Pipe({name: 'photoInUse'})
export class PhotoInUseFilterPipe implements PipeTransform {
  transform(value: IApiPhoto[], isUsed?: boolean): IApiPhoto[] {
    if (!value) return [];
    return value.filter(photo => isUsed === null || isUsed === photo.isUsed);
  }
}